import React, { Component } from 'react';
import { RadioButtonGroup } from '../../ui';
import { translate } from 'react-i18next';
import { UserDataConsumer, ResponsiveLayout } from '../../utils';
import { View } from 'react-native';

class UnitMeasurementSystemSelection extends Component {
    render() {
        const { t, optionTextStyle = {}, selectedUnitSystemImperial, optionInfoContainer,
        setUnitSystemPreferenceToMetric, setUnitSystemPreferenceToImperial,inactiveStyle,containerStyle} = this.props;
        return (
            <View>
                <RadioButtonGroup optionInfoContainer={optionInfoContainer} containerStyle={containerStyle}
                    options={[{
                        name: t('imperial'),
                        isSelected: selectedUnitSystemImperial,
                        setOption: setUnitSystemPreferenceToImperial,
                        style: optionTextStyle,
                    }, {
                        name: t('metric'),
                        isSelected: !selectedUnitSystemImperial,
                        setOption: setUnitSystemPreferenceToMetric,
                        style: optionTextStyle,
                    }]}
                    inactiveStyle={inactiveStyle}
                />
            </View>
        );
    }
}

UnitMeasurementSystemSelection = UserDataConsumer(UnitMeasurementSystemSelection);
export default translate(['settings', 'tracking'], { wait: true })(UnitMeasurementSystemSelection);
